import axios from 'axios';

const STORAGE_KEY = 'crowdblue_cookie_preferences';

export function getStoredCookiePreferences() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function getCookiePreferenceStatus() {
  return axios.get('/api/cookie-preferences/status').then((res) => res.data);
}

export function saveCookiePreferences(data) {
  return axios.post('/api/cookie-preferences', data).then((res) => res.data);
}
